import { cartClient } from '../common/cartClient';
import { eventClient } from '../common/eventClient';
import type { ResolveActorResponse, TrackEventRequest } from './utils/types';

class PersonalizationAPIClient {
  public async resolveActor(currentActorId?: string): Promise<ResolveActorResponse> {
    const body = currentActorId ? { actorId: currentActorId } : {};
    return await cartClient.post('/actors/resolve', body).then((res) => res.data);
  }

  public async trackEvent(payload: TrackEventRequest): Promise<void> {
    await eventClient.post('/personalization/event', payload);
  }
}

export const personalizationAPIClient = new PersonalizationAPIClient();
